export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: 'cat-001',
    name: '行动方法论',
    slug: 'action-methodology',
    description: '科学、系统、可操作的行动方法，帮你建立属于自己的执行力体系',
    icon: 'ri-flashlight-line',
    count: 3,
  },
  {
    id: 'cat-002',
    name: '拖延心理学',
    slug: 'procrastination-psychology',
    description: '从心理学和神经科学角度剖析拖延的根源，知己知彼才能对症下药',
    icon: 'ri-mental-health-line',
    count: 2,
  },
  {
    id: 'cat-003',
    name: '习惯养成',
    slug: 'habit-building',
    description: '微习惯、习惯堆叠、环境设计——让好习惯变得像刷牙一样自然',
    icon: 'ri-loop-left-line',
    count: 1,
  },
  {
    id: 'cat-004',
    name: '成功案例',
    slug: 'success-stories',
    description: '真实人物的转型故事，用别人的经历点燃你自己的行动火花',
    icon: 'ri-star-line',
    count: 1,
  },
  {
    id: 'cat-005',
    name: '每日行动',
    slug: 'daily-action',
    description: '每日行动指南、晨间仪式、晚间复盘，帮你过好行动力的每一天',
    icon: 'ri-sun-line',
    count: 1,
  },
];